import { render, staticRenderFns } from "./add.vue?vue&type=template&id=7fb38a09&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"
import style0 from "./add.vue?vue&type=style&index=0&id=7fb38a09&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb38a09",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/adam/Documents/Private_Repository/sjtx/backendAdmin/sjtx_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fb38a09')) {
      api.createRecord('7fb38a09', component.options)
    } else {
      api.reload('7fb38a09', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=7fb38a09&scoped=true", function () {
      api.rerender('7fb38a09', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/market/activity/apply/add.vue"
export default component.exports